// 액세스/리프레시 토큰 단일 보관소.
// auth 컨텍스트와 api 클라이언트가 같은 토큰을 보도록 메모리 + localStorage 로 공유한다.
// api 클라이언트는 매 요청 시 여기서 최신 액세스 토큰을 읽어 헤더에 싣는다(자동 갱신 후에도 항상 최신).

const ACCESS_KEY = "oncare.admin.accessToken";
const REFRESH_KEY = "oncare.admin.refreshToken";

let accessToken: string | null = null;
let refreshToken: string | null = null;
let loaded = false;

type Listener = () => void;
const listeners = new Set<Listener>();

function ensureLoaded() {
  if (loaded || typeof window === "undefined") return;
  accessToken = localStorage.getItem(ACCESS_KEY);
  refreshToken = localStorage.getItem(REFRESH_KEY);
  loaded = true;
}

export function getAccessToken(): string | null {
  ensureLoaded();
  return accessToken;
}

export function getRefreshToken(): string | null {
  ensureLoaded();
  return refreshToken;
}

export function setTokens(next: { accessToken: string; refreshToken: string }): void {
  accessToken = next.accessToken;
  refreshToken = next.refreshToken;
  loaded = true;
  if (typeof window !== "undefined") {
    localStorage.setItem(ACCESS_KEY, next.accessToken);
    localStorage.setItem(REFRESH_KEY, next.refreshToken);
  }
  notify();
}

export function clearTokens(): void {
  accessToken = null;
  refreshToken = null;
  loaded = true;
  if (typeof window !== "undefined") {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  }
  notify();
}

/** 토큰 변경(갱신·로그인·만료) 구독. AuthProvider 가 React 상태를 동기화하는 데 사용. */
export function subscribeTokens(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notify() {
  listeners.forEach((l) => l());
}
